<template>
  <div class="look">
    <div class="tips">
      <div class="tips-left">
        <i class="iconfont iconcuowu"></i>
        <span>如果证书信息有误，请点击帮助</span>
      </div>
      <div class="tips-right">
        <div class="help" @click="handleClickHelp">帮助</div>
      </div>
    </div>
    <img v-if="cert_url" :src="cert_url" />

    <van-popup class="van-popup-help" v-model="show1" :close-on-click-overlay="false">
      <main class="help-popup">
        <header class="head">
          温馨提示
        </header>
        <section class="content">
          <div class="title1">如果您的这张证书信息有误，可以撤回，请注意以下规则：</div>
          <div class="title2 first">
            1、2023年X月X日以后申请的证书才可以撤回
          </div>
          <div class="title2">
            2、一天只能进行一次撤回操作
          </div>
          <div class="title2">
            3、请再次申请之前，修改并确认好个人信息
          </div>
          <div class="title2">
            4、撤回后能再次申请，可以在“可申请”中查看到该活动
          </div>
          <div class="title2 last">
            5、再次申请的证书只修改个人信息，学时不做更改处理
          </div>
          <input type="text" class="input" placeholder="请输入“撤回”" v-model="value" />
        </section>
        <footer class="footer">
          <div class="cancel" @click="handleCancel">取消</div>
          <div class="confirm" @click="handleConfirm">确认</div>
        </footer>
      </main>
    </van-popup>

    <van-popup class="van-popup-help" v-model="show2" :close-on-click-overlay="false" @closed="handlePopupClosed">
      <main class="hint">
        <section class="hint-top">
          <img class="logo" :src="logo" v-if="logoShow" />
          <div class="title">{{ msg }}</div>
        </section>
        <section class="hint-bottom" @click="handleConfirm2">确认</section>
      </main>
    </van-popup>
  </div>
</template>

<script>
import {revokeEventClassHour} from '@/api/dd'
import {formatDate} from '@/filters'
import {certificateslist} from '@/api'
export default {
  name: 'certificate-look',
  data() {
    return {
      logo: require('@/assets/image/yes.png'),
      show1: false,
      show2: false,
      value: '',

      logoShow: false,
      msg: '',
      cert_id: null,
      cert_url: null,
      last_revoke_time: null,
      today_time: null
    }
  },
  computed: {
    /* user信息 */
    userInfo() {
      return this.$store.state.userInfo
    }
  },
  methods: {
    handleClickTest() {
      this.$router.replace({
        path: '/certificate/index',
        query: {
          index: 2
        }
      })
    },
    async handleGetCertPic() {
      try {
        const res = await certificateslist({
          applyId: this.$route.params.id,
          userId: this.userInfo.id,
          pageNo: 1,
          pageSize: 10
        })
        if (res.code === 0 && res.success) {
          // 修复 item 未定义错误，统一使用 res.data[0]
          const imageUrl = await this.$divToCavasToimg(
            res.data[0].certificateJson,
            '',
            '',
            '',
            res.data[0].certificateSealUrl
          )
          // 建议将生成的图片地址赋值给 cert_url 以便展示
          this.cert_url = imageUrl
        }
      } catch (error) {
        console.error('获取证书图片失败', error)
      }
    },
    handleClickHelp() {
      this.show1 = true
    },
    handleCancel() {
      this.value = ''
      this.show1 = false
    },
    handleConfirm() {
      if (this.value !== '撤回') {
        this.$Toast.fail('输入错误')
        return false
      }
      console.log('this.cert_id', this.cert_id)
      if (!this.cert_id || !this.last_revoke_time) {
        this.msg = '该证书生成时间超过期限，无法撤回'
        this.show2 = true
      } else if (this.last_revoke_time === this.today_time) {
        this.msg = '一天只能进行一次撤回操作'
        this.show2 = true
      } else {
        revokeEventClassHour({applyId: this.$route.params.id}).then(res => {
          if (res.code === 0 && res.success) {
            this.show2 = true
            this.msg = '撤回成功,请尽快修改个人信息后再次申请证书'
            this.logoShow = true
            this.handleCancel()
          }
        })
      }
    },
    handleConfirm2() {
      this.show2 = false
      this.logoShow = false
      this.$router.replace({
        path: '/certificate/index',
        query: {
          index: 2
        }
      })
    },
    handlePopupClosed() {
      this.logoShow = false
      this.msg = ''
    }
  },
  mounted() {
    this.cert_id = this.$route.query.cert_id
    this.last_revoke_time = this.$route.query.last_revoke_time
      ? formatDate(new Date(Number(this.$route.query.last_revoke_time)), 'yyyy-MM-dd')
      : null
    this.today_time = formatDate(new Date().getTime(), 'yyyy-MM-dd')
    this.handleGetCertPic()
  }
}
</script>

<style lang="scss" scoped>
.look {
  position: relative;
  display: flex;
  flex-direction: column;
  justify-content: center;
  width: 100%;
  height: 100vh;
  background-color: #000000;
  .tips {
    position: absolute;
    left: 0;
    top: 0;
    display: flex;
    align-items: center;
    justify-content: space-between;
    width: 100%;
    height: 52px;
    padding: 12px;
    font-size: 14px;
    box-sizing: border-box;
    .tips-left {
      display: flex;
      align-items: center;
      color: #fff;
      i {
        font-size: 18px;
      }
      span {
        margin-left: 5px;
      }
    }
    .tips-right {
      .help {
        width: 52px;
        height: 28px;
        text-align: center;
        line-height: 28px;
        box-sizing: border-box;
        border-radius: 4px;
        color: #fff;
        border: 1px solid #ffffff;
      }
    }
  }
  img {
    width: 100%;
    height: 265px;
  }
}
.van-popup-help {
  border-radius: 10px;
}
.help-popup {
  width: 280px;
  font-size: 14px;
  .head {
    width: 100%;
    height: 66px;
    text-align: center;
    line-height: 66px;
    border-radius: 10px 10px 0 0;
    font-size: 16px;
    font-weight: 600;
    color: #000;
  }
  .content {
    width: 100%;
    padding: 4px 20px 20px 20px;
    box-sizing: border-box;
    .title1 {
      line-height: 24px;
      color: #4d4d4d;
    }
    .title2 {
      font-weight: 600;
      line-height: 24px;
      color: #262626;
      &.first {
        margin-top: 12px;
      }
      &.last {
        margin-bottom: 12px;
      }
    }
    .input {
      width: 100%;
      height: 44px;
      padding: 0 12px;
      box-sizing: border-box;
      border: none;
      background: #f5f5f5;
      border-radius: 4px;
      &::placeholder {
        color: #b3b3b3;
      }
    }
  }
  .footer {
    display: flex;
    align-items: center;
    width: 100%;
    height: 48px;
    border-top: 1px solid rgba(#000000, 0.1);
    box-sizing: border-box;
    border-radius: 0 0 10px 10px;
    div {
      text-align: center;
      line-height: 48px;
      flex: 1;
      height: 100%;
      box-sizing: border-box;
      font-weight: 600;
      &.cancel {
        color: #1a1a1a;
        border-right: 1px solid rgba(#000000, 0.1);
      }
      &.confirm {
        color: #007aff;
      }
    }
  }
}

.hint {
  width: 280px;
  font-size: 14px;
  background: #fff;
  .hint-top {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    width: 100%;
    padding: 21px;
    box-sizing: border-box;
    .logo {
      margin-bottom: 16px;
      width: 42px;
      height: 42px;
      border-radius: 50%;
    }
    .title {
      line-height: 21px;
      text-align: center;
      font-size: 15px;
      color: #1a1a1a;
    }
  }
  .hint-bottom {
    width: 100%;
    height: 48px;
    line-height: 48px;
    text-align: center;
    font-size: 15px;
    font-weight: 500;
    color: #007aff;
    box-shadow: inset 0px 1px 0px 0px rgba(0, 0, 0, 0.1);
    /* border-top: 1px solid rgba(#000000, 0.1); */
  }
}
</style>
